import LineImage from "../core/shapes/imageParts/lineImage";
import EventManager from "../store/sqftEventManager";
import PointV2, {CORE_POINT_LAYOUTS} from "../core/shapes/pointV2";
//import line from "../core/shapes/line";

/**
 *
 * @param points[]
 * @param parent
 * @return lines[{}]
 */
export const createImageLinesFromPoints = (points, parent) => {
  let lines = [];

  for (let i = 0; i < points.length; i++) {
    const shapeLine = new LineImage(
      points[i],
      points[(i + 1) % points.length],
      parent,
      i,
      {isResizable: parent.params.isResizable}
    );
    // const shapeLine = new line([i], points[(i + 1) % points.length]);
    // void  parent;

    lines.push(shapeLine);
  }

  return lines;
};


/**
 * @param x
 * @param y
 * @param parent
 * @return {PointV2}
 */
export const getImagePoint = (x, y, parent) => {
  let pointState = {
    priority: EventManager.priorities.BOX_POINT,
    movable: false,
    isCentered: true,
    isResizedByPoint: false,
    isScaledByPoint: false,
    isVisibleOnHover: false,
  };
  let pointDesign = {
    radius: 0, // hide corner points
    lineWidth: 1,
    layout: CORE_POINT_LAYOUTS.black
  };

  return new PointV2(x, y, parent, pointState, pointDesign);
}
